import * as a from "react";
const t = (e) => /* @__PURE__ */ a.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M21.14 2H3.083a.854.854 0 00-.608.255.876.876 0 00-.251.616v5.842a.246.246 0 00.085.174c.061.025.129.025.19 0a14.025 14.025 0 013.8-.357c.862-.013 1.724.031 2.58.13a.212.212 0 00.176-.059.218.218 0 00.064-.175v-.331c0-.808.318-1.584.882-2.155a2.99 2.99 0 012.128-.893 2.99 2.99 0 012.128.893c.564.571.881 1.347.881 2.155 0 .548-.464 3.082-3.018 3.038a.187.187 0 00-.154.062.2.2 0 00-.06.156v2.612a.214.214 0 00.215.218h9.02a.855.855 0 00.607-.255.876.876 0 00.252-.616V2.87c0-.23-.09-.452-.252-.615A.855.855 0 0021.14 2zM5.233 5.918a.852.852 0 01-.478-.147.868.868 0 01-.365-.893.874.874 0 01.235-.446.857.857 0 01.937-.189.862.862 0 01.386.32.879.879 0 01-.107 1.1.854.854 0 01-.608.255zm13.758 6.095a.852.852 0 01-.478-.147.869.869 0 01-.366-.894.873.873 0 01.236-.445.856.856 0 01.937-.19.878.878 0 01.279 1.42.855.855 0 01-.608.256zM6.3 19.85a13.46 13.46 0 01-4.016-.55.205.205 0 00-.198 0 .218.218 0 00-.086.175v1.654c0 .48 1.926.871 4.3.871 2.372 0 4.298-.392 4.298-.87V19.5a.202.202 0 00-.094-.174.196.196 0 00-.198 0 13.372 13.372 0 01-4.007.522zM2.284 15.818a.204.204 0 00-.198 0 .216.216 0 00-.086.174v2.116a.229.229 0 00.112.192c1.332.528 2.759.765 4.187.696a9.805 9.805 0 004.18-.705.208.208 0 00.12-.192v-2.08a.202.202 0 00-.095-.175.196.196 0 00-.198 0 13.366 13.366 0 01-4.007.523 13.463 13.463 0 01-4.015-.549z",
      fill: "#333"
    }
  ),
  /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M2 10.707v.435a.228.228 0 00.112.192 10.04 10.04 0 004.187.697 9.803 9.803 0 004.18-.706.208.208 0 00.12-.191v-.427c0-.479-1.927-.87-4.3-.87-2.373 0-4.299.435-4.299.87zM2.284 12.335a.204.204 0 00-.198 0A.218.218 0 002 12.51v2.116a.229.229 0 00.112.192c1.332.528 2.759.765 4.187.696a9.803 9.803 0 004.18-.705.208.208 0 00.12-.191v-2.081a.202.202 0 00-.095-.175.196.196 0 00-.198 0 13.366 13.366 0 01-4.007.523 13.46 13.46 0 01-4.015-.549z",
      fill: "#333"
    }
  )
);
export {
  t as default
};
